class HomePageClickTracker {
  constructor(containerSelector = 'body') {
    this.container = document.querySelector(containerSelector);
    this.defaultEvent = 'home_content';
    
    this.init();
  }

  init() {
    if (!this.container) return;

    this.container.addEventListener('click', (event) => {
      const target = event.target;
      const trackingScript = this.findTrackingScript(target);

      if (trackingScript) {
        event.preventDefault();
        event.stopPropagation();
        
        const trackingData = this.extractTrackingData(trackingScript);
        const overrideUrl = this.findClosestUrl(target);

        if (target.hasAttribute('data-tracking-subdetail')) {
          trackingData['content_subdetail'] = target.getAttribute('data-tracking-subdetail');
        }
        
        if (overrideUrl) {
          trackingData['content_url'] = overrideUrl;
        }

        this.pushToDataLayerAndNavigate(trackingData, overrideUrl, event, target);
      }
    });
  }

  findTrackingScript(el) {
    let element = el;

    while (element && element.tagName !== 'SECTION') {
      element = element.parentElement;
    }

    if (element) {
      const script = element.querySelector('script[id*="tracking-data"]');

      if (script) return script;
    }

    return null;
  }
 
  extractTrackingData(script) {
    if (!script) return null;

    try {
      const jsonData = JSON.parse(script.textContent);
      
      const trackingData = {
        event: this.defaultEvent,
        content_block: jsonData.block || 'null',
        content_location: jsonData.index || 'null',
        content_detail: jsonData.detail || 'null',
        content_subdetail: jsonData.subdetail || 'null',
        content_url: 'null'
      };

      if (jsonData.id) {
        trackingData.content_id = jsonData.id;
      }

      return trackingData;
    } catch (error) {
      console.error('Failed to parse tracking JSON:', error);
      return null;
    }
  }

  findClosestUrl(el) {
    if (!el) return null;

    if (el.hasAttribute?.('data-tracking-url')) {
      return el.getAttribute('data-tracking-url');
    } 

    if (el.querySelector?.('[data-tracking-url]')) { 
      return el.querySelector?.('[data-tracking-url]').getAttribute('data-tracking-url'); 
    }

    if (el.tagName === 'A' && el.href) { 
      return el.href; 
    }

    if (el.querySelector?.('a[href]')) { 
      return el.querySelector?.('a[href]').href; 
    }

    return null;
  }

  pushToDataLayerAndNavigate(data, url, originalEvent, targetElement) {
    if (!data) return;
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);

    // FOR TESTING PURPOSES: Store the last tracking event in sessionStorage
    let event = JSON.parse(sessionStorage.getItem('lastTrackingEvent')) || [];
    event.push(data);
    sessionStorage.setItem('lastTrackingEvent', JSON.stringify(event));

    if (targetElement.tagName === 'A' && targetElement.href || targetElement.hasAttribute('data-tracking-url')) {
      if (url) {
        setTimeout(() => {
          if (originalEvent.ctrlKey || originalEvent.metaKey || originalEvent.shiftKey || originalEvent.button === 1) {
            window.open(url, '_blank');
          } else {
            window.location.href = url;
          }
        }, 100);
      }
    }
  }
}